import { Box } from '../../../imports/muiImport';
import { useState, useSelector } from '../../../imports/generalImport';
import UserDetailPayment from './paymentUtils/UserDetailPayment';
import UserPayButton from './paymentUtils/UserPayButton';
import { useAuth } from '../../../hooks/contexts/AuthContext';
import PaymentOrderReceipt from './paymentUtils/PaymentOrderReceipt';
import PayFromWallet from './paymentUtils/PayFromWallet';

function Payment() {
    const [walletPayment, setWalletPayment] = useState({
        paymentMethod: 1,
        isWalletPayment: false,
    });
    const { isLoggedIn } = useAuth();

    return (
        <Box>
            <PaymentOrderReceipt isWalletAccepted={walletPayment.isWalletPayment} />
            {isLoggedIn && (
                <Box sx={{ display: { xs: 'block', sm: 'block', md: 'none' } }}>
                    <UserDetailPayment />
                </Box>
            )}

            <Box
                sx={{
                    my: 3,
                    border: '1.5px solid',
                    borderColor: 'divider',
                    borderRadius: 2.5,
                    backgroundColor: 'white.main',
                    pt: 1,
                    pb: 2,
                    px: 2,
                }}
            >
                {isLoggedIn && (
                    <PayFromWallet walletPayment={walletPayment} setWalletPayment={setWalletPayment} />
                )}

                <UserPayButton isLoggedIn={isLoggedIn} walletPayment={walletPayment} />
            </Box>

        </Box>
    );
}

export default Payment;
